import { render } from "./DocumentFieldTrainingTable.vue?vue&type=template&id=e90edc4c&scoped=true&ts=true"
import script from "./DocumentFieldTrainingTable.vue?vue&type=script&lang=ts"
export * from "./DocumentFieldTrainingTable.vue?vue&type=script&lang=ts"

import "./DocumentFieldTrainingTable.vue?vue&type=style&index=0&id=e90edc4c&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e90edc4c"]])

export default __exports__